import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import {
  ChevronDown,
  ChevronRight,
  List,
  BoxSeam,
  People,
  Shop,
  Cart3,
  CreditCard,
  BarChart,
  Grid,
} from "react-bootstrap-icons";
import "../../styles/admin-sidebar.css";

export default function AdminSidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_PRODUCT_SERVICE_URL + "/products/categories")
      .then((res) => setCategories(res.data?.content || []))
      .catch((err) => console.error(err));
  }, []);

  const links = [
    { name: "Users", path: "/admin/users", icon: <People /> },
    { name: "Sellers", path: "/admin/sellers", icon: <Shop /> },
    { name: "Orders", path: "/admin/orders", icon: <Cart3 /> },
    { name: "Payments", path: "/admin/payments", icon: <CreditCard /> },
    { name: "Reports", path: "/admin/reports", icon: <BarChart /> },
  ];

  return (
    <aside className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* Header */}
      <div className="sidebar-header d-flex align-items-center justify-content-between">
        {!collapsed && (
          <div>
            <h5 className="mb-0">
              {/* <Grid className="me-2" /> */}
              Admin
            </h5>
            <small className="text-muted">Console</small>
          </div>
        )}

        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => setCollapsed(!collapsed)}
        >
          <List />
        </button>
      </div>

      {/* Navigation */}
      <div className="list-group list-group-flush">
        {links.map((link) => (
          <NavLink
            key={link.path}
            to={link.path}
            title={collapsed ? link.name : ""}
            className={({ isActive }) =>
              `list-group-item list-group-item-action d-flex align-items-center ${
                isActive ? "active" : ""
              }`
            }
          >
            <span className="sidebar-icon">{link.icon}</span>

            {!collapsed && <span className="ms-2">{link.name}</span>}
          </NavLink>
        ))}

        {/* Products Section */}
        <div>
          <button
            className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
            onClick={() => setShowCategories(!showCategories)}
          >
            <span className="d-flex align-items-center">
              <BoxSeam className="sidebar-icon" />

              {!collapsed && <span className="ms-2">Products</span>}
            </span>

            {!collapsed &&
              (showCategories ? <ChevronDown /> : <ChevronRight />)}
          </button>

          {!collapsed && (
            <div className={`collapse ${showCategories ? "show" : ""}`}>
              <div className="list-group list-group-flush ms-3">
                {categories.map((cat) => (
                  <NavLink
                    key={cat.id}
                    to={`/admin/products/category/${cat.id}`}
                    className={({ isActive }) =>
                      `list-group-item list-group-item-action ${
                        isActive ? "active" : ""
                      }`
                    }
                  >
                    {cat.name}
                  </NavLink>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}
